import { render, staticRenderFns } from "./PlatosMenu.vue?vue&type=template&id=f8299cfc&scoped=true&"
import script from "./PlatosMenu.vue?vue&type=script&lang=js&"
export * from "./PlatosMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlatosMenu.vue?vue&type=style&index=0&id=f8299cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8299cfc",
  null
  
)

export default component.exports